<ng-container *ngIf="cardToken$ | async as cardToken; else addCard">
  <div
    class="bg-glass ecash-button d-flex justify-content-between align-item-center"
    [ngClass]="{
      'bg-frozen': cardToken.Frozen,
    }"
  >
    <div class="card-token-number text-white">
      <ng-container [ngSwitch]="cardToken?.CardType">
        <img class="card-type-image" *ngSwitchCase="1" [src]="'payment-icons/mastercard.svg' | contentAssetImage" />
        <img class="card-type-image" *ngSwitchCase="2" [src]="'payment-icons/amex.svg' | contentAssetImage" />
        <img class="card-type-image visa" *ngSwitchCase="3" [src]="'payment-icons/visa.svg' | contentAssetImage" />
        <img class="card-type-image" *ngSwitchCase="4" [src]="'payment-icons/discover.svg' | contentAssetImage" />
        <img class="card-type-image" *ngSwitchCase="5" [src]="'payment-icons/jcb.svg' | contentAssetImage" />
        <img class="card-type-image" *ngSwitchCase="7" [src]="'payment-icons/dinnersclub.svg' | contentAssetImage" />
        <img class="card-type-image" *ngSwitchCase="8" [src]="'payment-icons/unionpay.svg' | contentAssetImage" />
        <div class="card-type-image" *ngSwitchDefault></div>
      </ng-container>

      <div class="card-details d-flex align-items-center">
        <span>({{ cardToken.CardNumber.substr(12) }})</span>
        <span class="expiry">{{ 'member.card.expiry.date' | translate }} {{ cardToken.ExpiryDate | date : 'MM/YY' }}</span>
      </div>
    </div>

    <div class="ps-2 d-flex align-items-center">
      <div
        class="expiried-status bg-white rounded py-1 px-3 fw-normal font-size-12 text-danger"
        *ngIf="isExpiried(cardToken?.ExpiryDate)"
      >
        {{ 'card.token.expiried' | translate : { fgbdefault: 'EXPIRED' } }}
      </div>

      <a class="d-flex text-white ms-3" [ngClass]="{ 'text-white': cardToken.Frozen }" [routerLink]="cardRouteURL">
        <span class="icon material-icons text-white">keyboard_arrow_right</span>
      </a>
    </div>
  </div>
</ng-container>

<ng-template #addCard>
  <div class="bg-glass ecash-button">
    <a class="btn w-100 d-flex align-items-center justify-content-center text-white" [routerLink]="cardRouteURL">
      <span class="icon material-icons pe-2">add_card</span>
      <span class="font-size-14 font-heading add-card-text">{{ 'member.card.ecash.add' | translate }}</span>
    </a>
  </div>
</ng-template>
